import React, { PureComponent } from 'react';
import Plot from 'react-plotly.js';
import { Grid, Label, Segment, Divider } from 'semantic-ui-react';
import _ from 'lodash';

const colorList = [
  '#2ca02c', // cooked asparagus green
  '#1f77b4', // muted blue
  '#ff7f0e', // safety orange
  '#d62728', // brick red
  '#ff1114', // red
  '#9467bd', // muted purple
  '#8c564b', // chestnut brown
  '#e377c2', // raspberry yogurt pink
  '#7f7f7f', // middle gray
  '#bcbd22', // curry yellow-green
  '#17becf', // blue-teal
];

export default class RatingsChart extends PureComponent {
  constructor() {
    super();
    this.state = {
      data: null,
    };
  }

  renderFeedbackLabels(tagObj, color) {
    return Object.entries(tagObj).map(([tagNm, tagCnt]) => {
      return (
        <div>
          <Label key={tagNm} basic size={'tiny'} color={color}>
            {tagNm + ' | ' + tagCnt.toString()}
          </Label>
        </div>
      );
    });
  }

  componentDidMount() {
    const { data } = this.props;
    let ratingOutObj = {
      ratingVals: [],
      posFeedback: {},
      negFeedback: {},
    };
    data.forEach(rt => {
      if (rt.rating) {
        ratingOutObj['ratingVals'].push(rt.rating);
      }
      let feedbackObj;
      try {
        feedbackObj = JSON.parse(rt.meta);
      } catch (SyntaxError) {
        feedbackObj = {};
      }
      if (feedbackObj.feedback_tags) {
        if (rt.rating >= 5) {
          feedbackObj.feedback_tags.forEach(tg => {
            if (ratingOutObj['posFeedback'][tg]) {
              ratingOutObj['posFeedback'][tg] += 1;
            } else {
              ratingOutObj['posFeedback'][tg] = 1;
            }
          });
        } else {
          feedbackObj.feedback_tags.forEach(tg => {
            if (ratingOutObj['negFeedback'][tg]) {
              ratingOutObj['negFeedback'][tg] += 1;
            } else {
              ratingOutObj['negFeedback'][tg] = 1;
            }
          });
        }
      }
    });
    this.setState({
      data: ratingOutObj,
    });
  }

  render() {
    const { data } = this.state;
    if (!data) {
      return <div>No Data</div>;
    }
    const ratingData = data.ratingVals;
    const processedData = Object.assign(
      {
        1: 0,
        2: 0,
        3: 0,
        4: 0,
        5: 0,
      },
      _.countBy(ratingData),
    );
    const ordered = {};
    Object.keys(processedData)
      .sort()
      .forEach(function(key) {
        ordered[key] = processedData[key];
      });
    return (
      <Grid columns={2} divided>
        <Grid.Row>
          <Grid.Column width={7}>
            <Plot
              config={{
                displayModeBar: false,
              }}
              data={[
                {
                  values: Object.values(ordered),
                  labels: Object.keys(ordered).map(k => 'Rating: ' + k),
                  marker: {
                    colors: Object.keys(ordered).map(clrIdx => colorList[5 - clrIdx]),
                  },
                  hoverinfo: 'label+text+percent',
                  hole: 0.8,
                  type: 'pie',
                  sort: false,
                  textinfo: 'none',
                },
              ]}
              layout={{
                shapes: [
                  //line vertical

                  {
                    type: 'line',
                    x0: 0.2,
                    y0: 0.49,
                    x1: 0.8,
                    y1: 0.49,
                    line: {
                      color: 'rgb(200, 200, 200)',
                      width: 1,
                      dash: 'dashdot',
                    },
                  },
                ],
                annotations: [
                  {
                    font: {
                      size: 15,
                    },
                    showarrow: false,
                    text:
                      ratingData.length > 0
                        ? (
                            ratingData.reduce((a, b) => a + b, 0) / ratingData.length
                          ).toFixed(2)
                        : 'NA',
                    x: 0.5,
                    y: 0.6,
                  },
                  {
                    font: {
                      size: 10,
                    },
                    showarrow: false,
                    text:
                      ratingData.length > 0
                        ? ratingData.length +
                          ' rating' +
                          (ratingData.length === 1 ? '' : 's')
                        : 'NA',
                    x: 0.5,
                    y: 0.41,
                  },
                ],
                height: 130,
                width: 140,
                margin: {
                  l: 10,
                  r: 10,
                  b: 10,
                  t: 10,
                  pad: 5,
                },
                plot_bgcolor: 'rgba(0,0,0,0)',
                paper_bgcolor: 'rgba(0,0,0,0)',
                showlegend: false,
              }}
            />
          </Grid.Column>
          <Grid.Column width={9}>
            <Grid.Row>
              <Segment basic compact>
                {this.renderFeedbackLabels(data.posFeedback, 'green')}
              </Segment>
            </Grid.Row>
            <Divider />
            <Grid.Row>
              <Segment basic compact>
                {this.renderFeedbackLabels(data.negFeedback, 'red')}
              </Segment>
            </Grid.Row>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}
